<template>
     <div id="order-detail">
        
        <van-nav-bar
        title="休假申请基础信息明细"
        left-text="返回"
        left-arrow
        placeholder
        fixed
        @click-left="onClickLeft"
    />

    <div v-if="content != null && content != undefined && content != ''">
        <van-notice-bar
        left-icon="volume-o"
        :text="content"
    />
    </div>
        <van-cell-group style="margin-top:15px">
            <van-cell title="申请编号" value="内容">
            <!-- 使用默认插槽自定义内容 -->
                <div>{{orderInfo.applyNo}}</div>
            </van-cell>
        </van-cell-group>

        <van-cell-group style="margin-top:5px">
            <van-cell title="账号/申请人" value="内容">
                <div>{{orderInfo.account}}/{{orderInfo.username}}</div>
            </van-cell>
            <!-- <van-cell title="账号" value="内容">
                <div>{{orderInfo.account}}</div>
            </van-cell> -->
            <van-cell title="申请时间" value="内容">
                <!-- 使用 title 插槽自定义标题 -->
                <template #default>
                    <div>{{orderInfo.createTime}}</div>
                </template>
            </van-cell>
        </van-cell-group>

        <van-cell-group style="margin-top:5px">
            <van-cell title="休假类别（I）" value="内容">
                <div>{{orderInfo.categoryStr}}</div>
            </van-cell>
            <van-cell title="休假类别（II）" value="内容">
                <div>{{orderInfo.classifyStr}}</div>
            </van-cell>
            <van-cell title="开始时间" value="内容">
                <div>{{orderInfo.startTime}}</div>
            </van-cell>
            <van-cell title="结束时间" value="内容">
                <div>{{orderInfo.endTime}}</div>
            </van-cell>
            <van-cell title="休假原因" value="内容">
                <!-- 使用 title 插槽自定义标题 -->
                <template #default>
                    <div>{{orderInfo.reason}}</div>
                </template>
            </van-cell>
        </van-cell-group>

        <van-cell-group style="margin-top:5px">
            <van-cell title="申请状态" value="内容">
                <div>{{orderInfo.applyStatus}}</div>
            </van-cell>
            <van-cell title="拒绝理由" value="内容">
                <div>{{orderInfo.errorMsg}}</div>
            </van-cell>
        </van-cell-group>

        <div style="margin: 16px;">
            <van-button round block type="info" style="margin-bottom: 5px;" @click="updateApply()" native-type="submit">我要修改</van-button>
            <van-button round block type="warning" style="margin-bottom: 5px;" @click="addApply()" native-type="submit">快速复制</van-button>
            <van-button round block type="danger" style="margin-bottom: 5px;" @click="updateCancel()" native-type="submit">我要取消</van-button>
        </div>
    </div>
</template>

<script>

    import {formatDate} from "@/unitls";
    import {get,userCancellation} from "@/api/UserApply";
    import { Cell, CellGroup, Icon } from 'vant';
    import { Divider } from 'vant';
    import { NavBar } from 'vant';
    import { Dialog } from 'vant';
    import { NoticeBar } from 'vant';
    import {getContent} from "@/api/SystemMessage";
    import Vue from 'vue';
    Vue.use(Cell);
    Vue.use(CellGroup);
    Vue.use(NavBar);
    Vue.use(Icon);
    Vue.use(Divider);
    Vue.use(Dialog);
    Vue.use(NoticeBar)

    export default {
        name: "userApplyDetail",

        data() {
            return {
                id: this.$route.query.orderId,
                content:'',
                orderInfo: {
                    applyNo: '',
                    companyNo: '',
                    username: '',
                    account: '',
                    category: '',
                    classify: '',
                    categoryStr: '',
                    classifyStr: '',
                    reason: '',
                    createTime: '',
                    modifyTime: '',
                    applyStatus: '',
                    errorMsg: '',
                    startTime: '',
                    endTime: ''
                },
                title: '提示',
                messageVisible: false,
                message: "",
                reason: '',
                isShow: true
            }
        },

        mounted(){
            this.selectContent();
            this.requestDetail();
        },

        computed: {

        },

        methods: {
            selectContent(){
                getContent(2)
                    .then((response) => {
                       this.content =  response.data.content;
                    })
            },
            goToBack() {
                this.$router.go(-1);
            },
            onClickLeft() {
                this.$router.go(-1);
            },
            updateApply(){
                var sId = this.id;
                this.$router.push({path: '/updateUserApply', query: {sId}})
            },
            addApply(){
                var sId = this.id;
                this.$router.push({path: '/AddUserApply', query: {sId}})
            },
            goBack(){
                this.$router.push({path: '/order'});
            },
            updateCancel() {
                Dialog.confirm({
                    title: '提示',
                    theme: 'round-button',
                    confirmButtonColor: '#1989fa',
                    // cancelButtonColor: '#C8C9CC',
                    cancelButtonColor: '#969799',
                    message: '你确定要执行此操作的吗？',
                })
                .then(() => {
                    userCancellation(this.id)
                    .then((response) => {
                        // on confirm
                        if(response.data > 0){
                            this.$toast.success({
                            message:'取消成功',
                            duration: 1000,
                            onClose:()=>{
                              //此处写提示关闭后需要执行的函数
                              this.$router.push({path: '/order'})
                              this.$router.go(0);
                              }
                        });
                        }else{
                            this.$toast.fail("当前状态已取消，请勿重复提交！")
                        }
                    })
                })
                .catch(() => {
                    // on cancel
                });
            },
            requestDetail() {
                get(this.id)
                    .then((response) => {
                        if (response.code === this.$API_CODE.OK) {
                            this.orderInfo.applyNo = response.data.applyNo;
                            this.orderInfo.username = response.data.username;
                            this.orderInfo.account = response.data.account;
                            this.orderInfo.createTime = formatDate(response.data.createTime, 'yyyy-MM-dd hh:mm:ss');
                            this.orderInfo.category = response.data.category;
                            this.orderInfo.classify = response.data.classify;
                            this.orderInfo.categoryStr = response.data.categoryStr;
                            this.orderInfo.classifyStr = response.data.classifyStr;
                            this.orderInfo.startTime = response.data.startTime;
                            this.orderInfo.endTime = response.data.endTime;
                            this.orderInfo.reason = response.data.reason;
                            this.orderInfo.applyStatus = this.formatStatus(response.data.applyStatus);
                            this.orderInfo.errorMsg = response.data.errorMsg;
                        } else {
                            this.messageVisible = true;
                            this.message = response.message;
                            this.title = '提示';
                        }
                    });
            },
            formatStatus(value) {
                if (value === 1){
                    value = '申请中'
                }
                if (value === 2){
                    value = '审批通过'
                }
                if (value === 3){
                    value = '申请异常'
                }
                if (value === 4){
                    value = '用户取消'
                }
                if (value === 5){
                    value = '审批中'
                }
				if (value === 6){
                    value = '审批拒绝'
                }
                return value;
            }
        }
    }
</script>

<style scoped lang="scss">

    #order-detail {
        padding-bottom: 50px;
        .van-cell__title{   // sass 修改子组件样式  /deep/ 或者 >>>
            text-align: left;
        }
        .title {
            height: 35px;
            background: #FFFFFF;
            line-height: 30px;

            .back {
                height: 30px;
                float: left;
                margin-left: 10px;
            }

            text-align: center;
        }

        #detail-content {

            border: 1px solid #BDBDBD;
            margin: 20px;
            padding: 10px;
            border-radius: 5px;
            background: #FFFFFF;

            .item {
                padding-top: 10px;
                border-bottom: 1px solid #BDBDBD;

                .title {
                    float: left;
                }

                .text {
                    float: right;
                    margin-top: 5px;
                    text-align: right;
                    width: 75%;
                }
                .textReason {
                    float: right;
                    margin-top: 5px;
                    text-align: right;
                    width: 75%;
                }
            }
        }

        .operation-order {
            margin-left: 15px;
            margin-right: 15px;
            margin-top: 30px;
            border-bottom: 30px;
            color: #FFFFFF;

            .finish-delivered {
                height: 30px;
                width: 25%;
                float: left;
                line-height: 30px;
                background: #75b1f8;
                border-radius: 5px;
            }
            .change-delivered {
                height: 30px;
                width: 20%;
                position: absolute;
                left: 50%;
                margin-left: -10%;
                line-height: 30px;
                background: #75b1f8;
                border-radius: 5px;
            }
            .cancel-order {
                height: 30px;
                width: 25%;
                float: right;
                line-height: 30px;
                background: #ed3f14;
                border-radius: 5px;
                margin-left: 15px;
            }
        }
    }

    .order-detail-clear{
        clear: both;
    }


    .dialog-wrapper {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.8);
        z-index: 100;

    }
    .dialog-box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        z-index: 101;
        border-radius: 5px;

    }
    .dialog-close {
        position: absolute;
        top: 12px;
        right: 12px;
        color: #FFFFFF;
        font-size: 0.8rem;
    }
    .dialog-title {
        padding: 12px;
        color: #ffffff;
        font-size: 1rem;
        background: #64b1fe;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }
    .dialog-body {
        padding: 20px 30px 20px;
        overflow: auto;
        max-height: 25rem;

        .number {
            border: 1px solid #c0c0c0;
            border-radius: 5px;
            margin: 10px 0;
            width: 200px;
            position: relative;
            padding: 10px;

            .cell {
                height: 30px;
                line-height: 30px;
                margin-bottom: 5px;
            }

            p{
                float: left;
                margin-block-start: 0em;
                margin-block-end: 0em;
            }

            .name {
                line-height: 1rem;
                text-align: left;
                width: 45%;
            }

            .value {
                float: right;
            }

            .reb {
                color: #f56803;
                float: right;
            }

            .gift {
                text-align: left;
            }


        }
    }

    .dialog-bottom {

        button {
            float: left;
            width: 50%;
            height: 50px;
            line-height: 50px;
            color: #64b1fe;
            padding: 0;
            border: none;
        }
    }

    .radio-box{
        display: inline-block;
        position: relative;
        height: 25px;
        line-height: 25px;
        width: 190px;
        margin: 5px 0;
    }
    .radio {
        display: inline-block;
        width: 25px;
        height: 25px;
        vertical-align: middle;
        background-image: url(../../assets/choose2.png);
        background-size: 25px 25px;
        background-repeat: no-repeat;
    }
    .input-radio {
        display: inline-block;
        position: absolute;
        opacity: 0;
        width: 100%;
        height: 25px;
        right: 0;
        outline: none;
        -webkit-appearance: none;
        margin: 0;
    }
    .on {
        background-image: url(../../assets/choose3.png);
        background-size: 22px 22px;
        margin-right: -2px;
    }

    .reason {
        width: 100%;
        margin: 5px 0;
        border: 1px solid #cccccc;
        border-radius: 5px;
        padding: 10px;
        font-size: 0.9rem;
        height: 50px;
    }

    .close-button {
        height: 35px;
        line-height: 35px;
        width: 90%;
        background: #75b1f8;
        margin: auto;
        color: white;
        font-size: 1rem;
        border-radius: 5px;
    }

</style>